import {
    Box,
    Button,
    FormControl,
    FormControlLabel,
    Radio,
    RadioGroup,
    TextField,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
// import LabeledCheckbox from "../../TemplateProperties/TPCheckbox";
// import WorkflowSessionModal1 from "./WorkflowSessionModal1";
// import WorkflowSessionModal2 from "./WorkflowSessionModal2";
import { useDispatch, useSelector } from "react-redux";
import { lgDocPath } from "../../../../constants/languageDocPaths";
import { api } from "../../../../redux/api";
import DatePattern from "../../../ItemProperties/PatternModal/DatePattern";
import AddWorkflowSessionValuesModal2 from "./AddWorkflowSessionValuesModal2";
import AddWorkflowSessionValuesModal3 from "./AddWorkflowSessionValuesModal3";

export const AddWorkflowSessionValuesModal1 = ({ modalOpen, currentValue, setModalOpen, handleClose, currentRowKey, modalStates, setModalStates, finalValue, setFinalValue }) => {
    const { t } = useTranslation();
    const queryParams = useSelector((state) => state.queryParams);
    const [checked, setChecked] = useState(0);
    const [keyName, setKeyName] = useState('');
    const [datePattern, setDatePattern] = useState('');
    const [valid, setValid] = useState(true);
    const [dpNetworkCallMessage, setDpNetworkCallMessage] = useState('')
    const dispatch = useDispatch();

    const handleClose2 = (value = false, isOpenModal) => {
        setModalStates((prev) => {
            return {
                modalOpen: value,
                type: prev.type,
            }
        })
        setChecked(modalStates.type);
        if (isOpenModal) setModalOpen({ open: true, isFirstTime: false });
    }

    const valueHandler = (value = {}, previousValue, isFinishClicked) => {
        let finalString = "";
        if (modalStates.openModal && modalStates.type === '0') {
            finalString = previousValue;
        } else {
            const valuesArray = Object.keys(value);
            valuesArray.forEach((o, i) => { if (value[o]) finalString += value[o] + ((valuesArray.length - 1) === i ? "" : ",") });
            finalString = previousValue ? ((previousValue || '') + `%${finalString}%`) : `%${finalString}%`;
            setKeyName(finalString);
        }
        if (isFinishClicked) {
            setFinalValue(finalString);
        }
    }

    const testDateHandler = (key, val) => {
        if (!val) {
            setDpNetworkCallMessage(t('BOX_NO_FORMAT_WAS_SPECIFIED__SEL_CANCEL_TO_CLS_DIALOG_AND_RET_TO_MAIN_SCREEN'))
            setValid(false)
        }
        if (val) {
            dispatch(
                api.endpoints.validateDatePattern.initiate({
                    datePattern: encodeURIComponent(val),
                })
            ).then((response) => {
                if (response) {
                    if (response.data.current_state === 'ERROR') {
                        setValid(false)
                        setDpNetworkCallMessage(response.data.message)

                    } else {
                        if (key === 'fromModal') {
                            setDpNetworkCallMessage(response.data.message)
                        }
                        setValid(true)
                    }
                }
            })
        }
    };

    useEffect(() => {
        if (modalOpen.open && modalOpen.isFirstTime) {
            setKeyName(currentValue);
            setChecked(0);
        }
    }, [modalOpen])

    return (
        <>
            <Dialog
                open={modalOpen.open}
                fullWidth
                maxWidth="sm"
                sx={{ overflow: "hidden" }}
            >
                <DialogTitle className="dialog-header">
                    <div className="title">
                        {" "}
                        {t("DIAG_WORKFLOW_SESSION_VARIABLE_WIZARD2_TIT")}{" "}
                    </div>
                    <div className="description">
                        {" "}
                        {t("DIAG_WORKFLOW_SESSION_VARIABLE_WIZARD2_DESC")}{" "}
                    </div>
                </DialogTitle>
                <DialogContent
                    sx={{ overflow: "auto", width: "100%", padding: "0 !important" }}
                    className="modal-content"
                    dividers
                >
                    <Box padding={"20px"} className="dialog-header">
                        <div
                            style={{
                                marginBottom: "1rem",
                                fontSize: "15px",
                                textAlign: "justify",
                            }}
                        >
                            {t("DIAG_WORKFLOW_SESSION_VARIABLE_WIZARD2_MSG")}
                        </div>
                        <Box
                            sx={{
                                height: "100%",
                                overflowX: "hidden",
                                maxHeight: "400px",
                                borderRadius: "0.2rem",
                                fontSize: "1.2rem",
                                display: "grid",
                                gap: "px",
                                overflow: "hidden",
                                margin: "1rem  0 2rem 0",
                            }}
                        >
                            <RadioGroup
                                aria-labelledby="demo-controlled-radio-buttons-group"
                                name="controlled-radio-buttons-group"
                                value={checked}
                                onChange={(e) => {
                                    setChecked(e.target.value)
                                }}
                            >
                                <FormControlLabel
                                    value={"0"}
                                    control={<Radio />}
                                    label={t("BTN_ADD_VALUE_FROM_WFSESSION")}
                                />
                                <FormControlLabel
                                    value={"1"}
                                    control={<Radio />}
                                    label={t("BTN_ADD_VALUE_FROM_CALLINGWORKFLOW")}
                                />
                                <FormControlLabel
                                    value={"2"}
                                    control={<Radio />}
                                    label={t("BTN_ADD_VALUE_FROM_ACCOUNT_DATA")}
                                />
                                <FormControlLabel
                                    value={"3"}
                                    control={<Radio />}
                                    label={t("BTN_ADD_DATE_TIME_STAMP")}
                                />
                                <FormControlLabel
                                    value={"4"}
                                    control={<Radio />}
                                    label={t("BTN_SYSTEM_DATA")}
                                />
                            </RadioGroup>
                        </Box>

                        <Box>
                            <FormControl className="width-100" size="small">
                                <TextField
                                    variant="outlined"
                                    size="small"
                                    label={currentRowKey || t("COL_KEY_NAME")}
                                    type="text"
                                    className={"width-100"}
                                    name={"KEY_NAME"}
                                    value={keyName}
                                    onChange={(e) => {
                                        setKeyName(e.target.value)
                                    }}
                                />
                            </FormControl>
                        </Box>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button
                        size='small'
                        //   disabled={!actions.back}
                        variant="outlined"
                        color="primary"
                        onClick={() => {
                            setModalStates({
                                openModal: true,
                                type: checked
                            })
                            handleClose()
                        }}
                    >
                        {" "}
                        {t("BTN_NEXT")}
                    </Button>
                    <Button
                        size='small'
                        variant="outlined"
                        color="primary"
                        onClick={() => {
                            setFinalValue(keyName);
                            handleClose();
                        }}
                    >
                        {" "}
                        {t("BTN_FINISH")}
                    </Button>
                    <Button
                        size='small'
                        variant="outlined"
                        color="primary"
                        onClick={() => {
                            // resetStates();
                            handleClose(false);
                            setKeyName('');
                        }}
                    >
                        {" "}
                        {t("BTN_CANCEL")}
                    </Button>
                </DialogActions>
            </Dialog>
            <AddWorkflowSessionValuesModal2
                previousValue={keyName}
                showSelection={"true"}
                openModal={modalStates.openModal && modalStates.type === '0'}
                handleClose2={handleClose2}
                handleClose1={() => { }}
                resetStates={() => { }}
                valueHandler={valueHandler}
                sourceType="workflowSessionValue"
            />
            <AddWorkflowSessionValuesModal3
                previousValue={keyName}
                showSelection={"true"}
                valueHandler={valueHandler}
                handleClose={handleClose2}
                openModal={modalStates.openModal && modalStates.type === '1'}
                sourceType="sessionValue"
            />
            <AddWorkflowSessionValuesModal2
                previousValue={keyName}
                showSelection={"true"}
                sourceType="accountData"
                openModal={modalStates.openModal && modalStates.type === '2'}
                handleClose2={handleClose2}
                handleClose1={() => { }}
                resetStates={() => { }}
                valueHandler={valueHandler}
            />
            <AddWorkflowSessionValuesModal2
                previousValue={keyName}
                showSelection={"true"}
                sourceType="systemData"
                openModal={modalStates.openModal && modalStates.type === '4'}
                handleClose2={handleClose2}
                handleClose1={() => { }}
                resetStates={() => { }}
                valueHandler={valueHandler}
            />

            <DatePattern
                sourceType="sessionWorkflowModal"
                openModal={modalStates.openModal && modalStates.type === '3'}
                docPath={`${queryParams.baseUrl}/docs/${lgDocPath[queryParams.lang] || 'en'}/Workbench/dialogs/DateFormatter.html`}
                okHandler={(isFinishClicked) => {
                    setKeyName(keyName + `%TODAY,${datePattern}%`)
                    if (isFinishClicked) setFinalValue(keyName + `%TODAY,${datePattern}%`)
                    setDatePattern('');
                    setDpNetworkCallMessage('');
                    handleClose2(false, true);
                }}
                handleClose={handleClose}
                onChangeHandler={setDatePattern}
                datePattern={datePattern}
                cancelHandler={() => handleClose2(false, true)}
                testDateHandler={testDateHandler}
                dpNetworkCallMessage={dpNetworkCallMessage}
                valid={valid}
            />
        </>
    )
}